/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Checkbox,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
} from '@material-ui/core';
import clsx from 'clsx';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import Fieldset from './Fieldset';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import {
  getBalanceThreshold,
  getbalancethresold,
  getDramsInvStartQtr,
  getEarliestDrugQtr,
  getManufacturerList,
  getPlanTypeValues,
  getRebateProgrameList,
  setSearchInput,
  getDisputeAmountComputedFields,
  setComputedFields,
} from '../Store/actions';
import { ManufactureTableHead } from './tableHeads';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  MANUFACTURER_IS_REQUIRED,
  NO_DATA,
  REBATE_SELECT,
} from '../../../../SharedModules/Errors/constantMessageData';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const RequestDisputeAmount = (props) => {
  const gridRef = useRef();
  const dispatch = useDispatch();

  const {
    isLoading,
    planType: planTypeList,
    rebateProgramList: rebateProgramListData,
    manufacturerList: manufactureListData,
    threshold,
    dramsInvoice,
    earliestQtr,
    errors,
    computedFileds,
    rebateProgram: rebateProgramValue,
    reportQuarter: reportQuarterValue,
    useBalanceThreshold,
    isAll,
    plan,
    // searchScreenVar: {

    // },
  } = useSelector((state) => state?.sharedState?.DisputeAmountReducer);

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [errorList, setErrorList] = React.useState(errors);
  const [manufactureList, setManufactureList] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [planType, setPlanType] = React.useState(plan);
  const [selectList, setSelectList] = React.useState([]);
  const [radioList, setRadioList] = React.useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [reportQuarter, setReportQuarter] = React.useState(reportQuarterValue);
  const [isSearchClicked, setIsSearchClicked] = React.useState(false);
  const [c, setC] = React.useState(0);
  const [isThreshold, setIsThreshold] = React.useState(false);
  React.useEffect(() => {
    setErrorList(errors);
  }, [errors]);

  const [reportQuarterOption, setReportQuarterOption] = React.useState([
    {
      name: 'All',
      value: 'All',
      disabled: false,
    },
    {
      name: 'DRAMS Invoice Start Quarter',
      value: 'DRAMS Invoice Start Quarter',
      disabled: false,
    },
    {
      name: 'Earliest Quarter for Drug Details',
      value: 'Earliest Quarter for Drug Details',
      disabled: false,
    },
  ]);

  const [checkboxValues, setCheckboxValues] = React.useState({
    isAllManufacturersSelected: isAll,
    isBalanceDueThreshold: useBalanceThreshold,
  });

  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);

  const [thresholdValue, setThresholdValue] = React.useState(threshold);

  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
          shortDesc: obj.shortDescription,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(plan || tempPlanType?.value);
    }
  }, [planTypeList]);

  React.useEffect(() => {
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
    handleScrollToEvent();
  }, []);

  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
    }
  }, [planType]);

  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));

    // if (list.length) {
    setSelectList(list);

    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );

    setRebateProgram(rebateProgramValue || tempRebateProgram?.id || '-1');

    const errors = errorList?.filter(
      (error) => error.field !== 'rebateProgram'
    );

    setErrorList([...errors]);
    // }
  };

  React.useEffect(() => {
    const errors = errorList?.filter((error) => error.field !== 'noData');

    if (manufactureListData.length === 0 && c > 1) {
      errors.push({
        field: 'noData',
        message: NO_DATA,
      });
    }

    setC(c + 1);
    if (errors) setErrorList([...errors]);

    setManufactureList(manufactureListData);
  }, [manufactureListData]);

  // on Changes rebateProgram API called
  React.useEffect(() => {
    dispatch(
      getDramsInvStartQtr({
        rebateProgCode: rebateProgram,
        allRpc: 0,
      })
    );
    dispatch(
      getEarliestDrugQtr({
        rebateProgramCd: rebateProgram,
      })
    );
  }, [rebateProgram]);

  /*
   if any of the following value changes it call manufacture lsit api
   thresholdValue, rebateProgram, checkboxValues.isBalanceDueThreshold
  */
  React.useEffect(() => {
    if (rebateProgram && rebateProgram !== '-1') {
      if (thresholdValue && checkboxValues.isBalanceDueThreshold) {
        dispatch(
          getManufacturerList({
            rebateProgramCd: rebateProgram,
            thresh: thresholdValue,
          })
        );
      } else {
        dispatch(
          getManufacturerList({
            rebateProgramCd: rebateProgram,
            thresh: 0,
          })
        );
      }
    }
  }, [thresholdValue, rebateProgram, checkboxValues.isBalanceDueThreshold]);

  // Threshold API is getting called from here
  React.useEffect(() => {
    dispatch(
      getBalanceThreshold({
        rebateProgramCd: rebateProgram,
      })
    );
  }, [rebateProgram]);

  React.useEffect(() => {
    setThresholdValue(threshold);
  }, [threshold]);

  const changeFullScreenView = () => setFullScreenView(!fullScreenView);

  // Handles the validation and if all is fine navigate to isplay screend
  const handleSearchClick = (
    e,
    onDoubleClick = false,
    selectedRowOnDoubleClick = ''
  ) => {
    const sRows = onDoubleClick
      ? [selectedRowOnDoubleClick]
      : (checkboxValues.isAllManufacturersSelected
          ? manufactureList
          : selectedRows) || [];

    const errors = [];
    if (rebateProgram === '-1') {
      errors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }
    if (sRows.length === 0 && !checkboxValues.isAllManufacturersSelected) {
      errors.push({
        field: 'manufactureSelect',
        message: MANUFACTURER_IS_REQUIRED,
      });
    }

    setErrorList(errors);
    /*
        if all the  error is cleaered then it will go to if block and
        set store value and navigate to Displayy Screen
    * */
    if (rebateProgram === '-1' || sRows.length === 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      return;
    }
    if (sRows.length && rebateProgram != '-1') {
      sRows.sort((a, b) =>
        a.mfgId > b.mfgId ? 1 : b.mfgId > a.mfgId ? -1 : 0
      );
      // Variable to get fullname of rebate program from rebate program list(selectList)
      let rebateProgrameName =
        selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
      rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
        rebateProgrameName?.shortDescr || ''
      }`;
      // Sets store value using this action dispatch
      dispatch(
        setSearchInput({
          errors: errors,
          selectedPlanType: radioList?.find((item) => item.value === planType)
            ?.shortDesc,
          rebateProgram,
          rebateProgrameName,
          selectedRows: sRows,
          reportQuarter,
          useBalanceThreshold: checkboxValues.isBalanceDueThreshold,
          plan: planType,
          isAll: checkboxValues.isAllManufacturersSelected,
          displayObj: {
            selectedPlanType: radioList?.find((item) => item.value === planType)
              ?.shortDesc,
            rebateProgram,
            rebateProgrameName,
            selectedRows: sRows,
            reportQuarter,
            useBalanceThreshold: checkboxValues.isBalanceDueThreshold,
            plan: planType,
            isAll: checkboxValues.isAllManufacturersSelected,
            dramsInvoice,
            earliestQtr,
            rebateProgramList: rebateProgramListData,
          },
        })
      );

      if (sRows.length === 1) {
        dispatch(setComputedFields([]));
        setIsSearchClicked(true);
        dispatch(
          getDisputeAmountComputedFields({
            rebateProgramCd: rebateProgram,
            qtr:
              reportQuarter === 'All'
                ? '1Q1991'
                : reportQuarter === 'DRAMS Invoice Start Quarter'
                ? dramsInvoice
                : reportQuarter === 'Earliest Quarter for Drug Details'
                ? earliestQtr
                : '',
            mfg: sRows[0]?.mfgId,
            thresh: isThreshold
              ? null
              : checkboxValues?.isBalanceDueThreshold
              ? threshold
              : 0,
          })
        );
      } else {
        // sets the name for the dispaly screen
        const updateTabs =
          JSON.parse(localStorage.getItem('tabItemsData')) === null
            ? []
            : JSON.parse(localStorage.getItem('tabItemsData'));

        updateTabs.push({
          navTo: '/displayManufacturerDisputedAmounts',
          value: 'Display Manufacturer Disputed Amounts',
        });

        localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));

        props.history.push({
          pathname: '/displayManufacturerDisputedAmounts',
        });
        dispatch(
          clearReduxForFilterAndSort('/displayManufacturerDisputedAmounts')
        );
      }
    }
  };

  if (isSearchClicked && computedFileds.length > 0) {
    setIsSearchClicked(false);
    // sets the name for the dispaly screen
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));

    updateTabs.push({
      navTo: '/displayManufacturerDisputedAmounts',
      value: 'Display Dispute Amounts Report',
    });

    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));

    props &&
      props.history &&
      props.history.push({
        pathname: '/displayManufacturerDisputedAmounts',
      });
    dispatch(clearReduxForFilterAndSort('/displayManufacturerDisputedAmounts'));
  }

  const cellClickedListener = (e) => {
    setSelectedRows(e?.data);
    handleSearchClick(null, true, e?.data);
  };

  // on Row select from table it sets for Display data
  const onSelectionChanged = (e) => {
    const selectedRows = e?.api?.getSelectedRows();
    setSelectedRows(selectedRows);
    const errors = errorList.filter(
      (error) => error.field !== 'manufactureSelect'
    );
    setErrorList([...errors]);
  };

  // If any error in errorlist it highlights the tab
  React.useEffect(() => {
    if (errorList?.length > 0) {
      tabHighLigther('/disputeAmounts', true);
    } else {
      tabHighLigther('/disputeAmounts', false);
    }
  }, [JSON.stringify(errorList)]);
      
  //remove no data error msg 
  React.useEffect(() => {
    dispatch(setSearchInput({ errors: [] }));
  }, [reportQuarter, checkboxValues.isAllManufacturersSelected, checkboxValues.isBalanceDueThreshold]);
   const [gridApi, setGridApi] = React.useState(null);
      const onGridReady = (params) => {
        setGridApi(params.api);
      };
      React.useEffect(() => {
        if (!gridApi || manufactureList === 0) return;
        const selectedRows = gridApi?.getSelectedRows();
        if (selectedRows?.length > 0) return;
        const firstNode = gridApi.getDisplayedRowAtIndex(0);
        if (firstNode) {
          firstNode.setSelected(true);
        }
      }, [gridApi, manufactureList]);
  
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />

      <CustomSeparator parent1="Summary Reports" parent2="Dispute Amount" />
      <DisplayErrorMessages
        errorMessages={[...errorList?.map((l) => l.message)]}
      />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-4 frr-two-col-radio">
                <RadioGroupComponent
                  data-testid="unallocated-balance-plan-by-radio-btn-plan"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Plan Type"
                  required
                  optionList={radioList || []}
                  defaultValue={planType}
                  filterAction={(value) => {
                    setPlanType(value);
                    setRebateProgram('-1');
                    dispatch(
                      setSearchInput({
                        rebateProgram: '-1',
                      })
                    );
                    const errors = errorList?.filter(
                      (error) => error.field !== 'noData'
                    );
                    errors && setErrorList([...errors]);
                  }}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                />
              </div>
              <div className="col-4 frr-one-col-radio">
                {/* <RadioGroupComponent
                  data-testid="unallocated-balance-quarter-radio-btn"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Report Quarter Option"
                  required
                  optionList={reportQuarterOption || []}
                  defaultValue={reportQuarter}
                  filterAction={(value) => setReportQuarter(value)}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                /> */}
                <fieldset
                  data-testid="radio-box-component"
                  className={clsx('radioBtnGroup custom-fieldset h-100')}
                >
                  <legend className="same-font-family">
                    Report Quarter Option
                    <span className={'mandatory'}>*</span>
                  </legend>
                  <div className="sub-radio no-margin">
                    <FormControl>
                      <RadioGroup
                        row
                        name={`rpt-qtr-opt-row-radio-buttons-group`}
                        defaultValue={reportQuarter}
                        value={reportQuarter}
                        data-testid="radio-box-group-control"
                        onChange={(e) => setReportQuarter(e.target.value)}
                      >
                        <FormControlLabel
                          value="All"
                          control={<Radio />}
                          label="All"
                          data-test="radio-all"
                        />
                        <FormControlLabel
                          value="DRAMS Invoice Start Quarter"
                          control={<Radio />}
                          label="DRAMS Invoice Start Quarter"
                          data-test="radio-Selected"
                        />
                        <FormControlLabel
                          value="Earliest Quarter for Drug Details"
                          control={<Radio />}
                          label="Earliest Quarter for Drug Details"
                          data-test="radio-Selected"
                          disabled={checkboxValues?.isAllManufacturersSelected}
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </fieldset>
              </div>
              <div className="col-4">
                <Fieldset label="Report Balance Due Threshold">
                  <div className="filter-checkbox">
                    <FormControlLabel
                      control={
                        <>
                          <div style={{ width: 210, marginLeft: 5 }}>
                            Use Report Balance Due Threshold:
                          </div>
                          <Checkbox
                            data-testid="abc"
                            color="primary"
                            onChange={(e) => {
                              setCheckboxValues({
                                ...checkboxValues,
                                isBalanceDueThreshold:
                                  !checkboxValues.isBalanceDueThreshold,
                              });
                              setIsThreshold(
                                checkboxValues?.isBalanceDueThreshold
                              );
                            }}
                            checked={checkboxValues.isBalanceDueThreshold}
                          />
                        </>
                      }
                    />
                  </div>
                </Fieldset>
              </div>
            </div>

            <div className="row" style={{ marginTop: 15 }}>
              <div className="col-4">
                <>
                  <Fieldset label="Rebate Program" required>
                    <SelectBoxComponent
                      data-testid="unallocated-balance-rebate-program-radio-btn"
                      id="filter-plan-by-radio-btn-action"
                      label="filter-plan-by-radio-btn-action"
                      labelName="Rebate Program"
                      required
                      select
                      selectedOne
                      optionList={selectList || []}
                      defaultValue={rebateProgram}
                      filterAction={(value) => {
                        setRebateProgram(value);
                        const errors = errorList?.filter(
                          (error) => error.field !== 'rebateProgram'
                        );
                        errors && setErrorList([...errors]);
                      }}
                      isError={
                        errorList?.find(
                          (error) => error.field === 'rebateProgram'
                        )?.message
                      }
                    />
                  </Fieldset>
                </>
              </div>
              <div className="col-4">
                <Fieldset
                  label="Manufacturers"
                  isError={
                    errorList?.filter(
                      (error) => error.field === 'manufactureSelect'
                    ).length > 0
                  }
                >
                  <div className="filter-checkbox">
                    <FormControlLabel
                      control={
                        <>
                          <div
                            style={{
                              width: 175,
                              marginLeft: 5,
                            }}
                          >
                            All Manufacturers:
                          </div>
                          <Checkbox
                            color="primary"
                            onChange={async (e) => {
                              setCheckboxValues({
                                ...checkboxValues,
                                isAllManufacturersSelected:
                                  !checkboxValues.isAllManufacturersSelected,
                              });
                              const errors = errorList.filter(
                                (error) => error.field !== 'manufactureSelect'
                              );
                              setErrorList([...errors]);
                              if (
                                !checkboxValues.isAllManufacturersSelected &&
                                reportQuarter ===
                                  'Earliest Quarter for Drug Details'
                              )
                                setReportQuarter('All');
                              const elem = document.getElementById('abc');
                              if (
                                elem &&
                                checkboxValues.isAllManufacturersSelected
                              ) {
                                //setTimeout(() => {
                                  await Promise.resolve();
                                  elem.scrollIntoView();
                                //}, 1000);
                              }
                            }}
                            checked={checkboxValues.isAllManufacturersSelected}
                          />
                        </>
                      }
                    />
                  </div>
                </Fieldset>
              </div>
            </div>
            <div className="row" style={{ marginTop: 30 }}>
              <div className="btn-wrapper col-12" tabIndex={0}>
                <Button
                  data-testid="view_detail_ia"
                  onClick={handleSearchClick}
                  className="btn btn-success btn-search float-right"
                >
                  <SVGComponent iconName="Icon-search" /> Search
                </Button>
              </div>
            </div>
          </>
        )}
        <div className="row" id="abc" style={{ marginTop: 15 }}>
          <>
            {/* {manufacturerError !== "" && (
              <div style={{ fontSize: 12, color: "red" }}>
                {manufacturerError}
              </div>
            )} */}
            {!checkboxValues.isAllManufacturersSelected && (
              <div className="unallocated" style={{ width: '100vw' }}>
                <TableGridWithFeatures
                  onSelectionChanged={onSelectionChanged}
                  cellClickedListener={cellClickedListener}
                  ref={gridRef}
                  gridCall={onGridReady}
                  gridHeight={viewPortHeight_355}
                  columnDefs={ManufactureTableHead}
                  rowData={manufactureList}
                  //   rowSelection="multiple"
                  rowMultiSelectWithClick
                  data-testid="onEditingStopped"
                  enterMovesDown
                  showResetFilter={false}
                  suppressCellFocus
                  hideTotalCount={false}
                  exportFile
                  fileName="Manufacturer List"
                  fullScreenView={fullScreenView}
                  handleFullScreenViewClick={changeFullScreenView}
                  frameworkComponents={{
                    TextBoxRender: (cellInfo) => {
                      const name = cellInfo?.value;

                      if (name && name.length > 30) {
                        return (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="labeler-tooltip">{name}</Tooltip>
                            }
                          >
                            <div>{name}</div>
                          </OverlayTrigger>
                        );
                      }
                      return <div>{name}</div>;
                    },
                  }}
                />
              </div>
            )}
          </>
        </div>
      </div>
    </div>
  );
};
export default RequestDisputeAmount;
